import { ProductDuration } from '@essent/common';
import {
  getContractAddressesDetails,
  getContractAddressLoading,
} from '@innogy/customer-details/store';
import { createSelector } from '@ngrx/store';
import { addMonths, getTime } from 'date-fns';

export const sixMonthsInMilliseconds =
  getTime(addMonths(Date.now(), 6)) - Date.now();

export const hasFixedContractsSelector = createSelector(
  getContractAddressesDetails,
  (contractAddresses) =>
    contractAddresses.contractAddress?.connections?.connection?.some(
      (connection) =>
        connection.contract?.some(
          (contract) => contract.durationInYears !== ProductDuration.FLEX
        )
    )
);

export const createHasExpiringContracts = (expirationTimeStamp: number) =>
  createSelector(
    getContractAddressesDetails,
    (contractAddresses) =>
      contractAddresses.contractAddress?.connections?.connection?.some(
        (connection) =>
          connection.contract?.some((contract) => {
            if (contract.endDate == null) {
              return false;
            }
            const endDate = new Date(contract.endDate);
            return (
              endDate != null &&
              endDate >= new Date() &&
              endDate <= new Date(Date.now() + expirationTimeStamp)
            );
          })
      ) ?? false
  );

export const isRetentionDataLoading = createSelector(
  getContractAddressLoading,
  (isLoadingContracts) => isLoadingContracts
);

export const isEligibleForRetention = (
  expirationTimeStamp: number = sixMonthsInMilliseconds
) =>
  createSelector(
    createHasExpiringContracts(expirationTimeStamp),
    hasFixedContractsSelector,
    (hasExpiringContracts, hasFixedContracts) =>
      (hasFixedContracts && hasExpiringContracts) || !hasFixedContracts
  );
